import axios from 'axios';
import axiosRetry from 'axios-retry';

class ApiService {
  constructor() {
    let options = {
      baseURL: "https://account.chauffeurbookingsoftware.com",
      //baseURL: "http://localhost:51438/",
      headers: {
        // csrf: "token",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      withCredentials: true,
    };
    if (window.websiteSettings.baseApiUrl)
      options.baseURL = window.websiteSettings.baseApiUrl;

    let service = axios.create(options);
    axiosRetry(service, {
      retries: 0,
      retryDelay: (retryCount) => {
        return retryCount * 1000;
      },
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }

  handleSuccess(response) {
    console.log("handleSuccess triggered");
    //TODO: check status to be ok 
    return response;
  }

  handleError(error) {
    console.log("handleError called");
    //TODO: remove this when we implement unitary erject failures
    //return Promise.reject(error);

    //TODO: implement custom errors
    switch (error.response.status) {
      case 401:
        //this.redirectTo(document, "/");
        break;
      // case 404:
      //     this.redirectTo(document, '/404');
      //     break;
      // default:
      //     this.redirectTo(document, '/500');
      //     break;
    }
    return Promise.reject(error);
  }

  redirectTo(document, path) {
    document.location = path;
  }

  get(path, callback) {
    //TODO: add  &timestamp=${new Date().getTime()} to url
    console.log("internal get");
    return this.service
      .get(path)
      .then((response) => callback(response.status, response.data));
  }

  patch(path, payload, callback) {
    return this.service
      .request({
        method: "PATCH",
        url: path,
        responseType: "json",
        data: payload,
      })
      .then((response) => callback(response.status, response.data));
  }

  post(path, payload, callback) {
    return this.service
      .request({
        method: "POST",
        url: path,
        responseType: "json",
        data: payload,
      })
      .then((response) => callback(response.status, response.data));
  }

  // METHODS
  getWebsiteSettings(apiKey) {
    return this.service.get("websitesApi/GetWebsiteSettings/" + apiKey);
  }

  login = (email, password, websiteGuid) => {
    let result = this.service.post("accountApi/webLogin", {
      email: email,
      password: password,
      websiteGuid: websiteGuid,
    });
    return result.then((response) => {
      console.log("login result", response);
      return response;
    });
  };

  changePassword(changePassModel) {
    return this.service.post("accountApi/changeUserPassword", changePassModel);
  }

  forgotPassword(email) {
    return this.service.post("/accountApi/forgotPassword", { email: email });
  }

  resetPassword(model) {
    return this.service.post("/accountApi/resetPassword", model);
  }

  tryGetToken = () => {
    let result = this.service.post("accountApi/tryGetToken");
    return result.then((response) => {
      console.log("tryGetToken result", response);
      return response;
    });
  };

  getUserProfile = (websiteGuid) => {
    return this.service.get("accountApi/getUserProfile/" + websiteGuid);
  };

  updateUserProfile = (userProfileModel) => {
    return this.service.post(
      "accountApi/updateUserProfile/" + userProfileModel.websiteGuid,
      userProfileModel
    );
  };

  getClientAccountTransactions = (webisteGuid, clientGuid) => {
    return this.service.get(
      "accountApi/getUserCreditInfo/" + webisteGuid + "/" + clientGuid
    );
  };

  getClientReservations = (/*token*/) => {
    return this.service.get("bookingApi/GetClientReservations/");
  };

  getReservationDetailsUsingHash = (urlHash /*, token*/) => {
    return this.service.get("bookingApi/GetClientReservationByHash/" + urlHash);
  };

  getReservationDetails = (guid /*, token*/) => {
    return this.service.get("bookingApi/GetClientReservation/" + guid);
  };

  getReservationCancellationInfo = (hash /* token */) => {
    return this.service.get("ABookingApi/GetBookingCancellationInfo/" + hash);
  };

  cancelReservation = (cancellationInfo /*, token*/) => {
    return this.service.post(
      "ABookingApi/CancelReservation/",
      cancellationInfo
    );
  };

  setupCardPayment = (model) => {
    return this.service.post(
      "BookingApi/GetIntentToPayBookingWithStripeSca/",
      model
    );
  };

  payBookingWithStripeSca = (paymentData) => {
    return this.service.post(
      "BookingApi/payBookingWithStripeSca/",
      paymentData
    );
  };

  payBookingWithPaypal = (paymentData) => {
    return this.service.post("BookingApi/PayBookingWithPaypal/", paymentData);
  };

  /**
   *
   * @param {any} bookingInfo
   */
  createBooking(bookingInfo) {
    return this.service.post(
      "bookingApi/createBookingFromWebsite",
      bookingInfo
    );
  }

  /**
   *
   * @param {any} bookingInfo
   */
  getTripPrice(bookingInfo) {
    /*public int WebsiteId { get; set; }
        public string PickupDateTime { get; set; }
        public BookingType Type { get; set; }
        public decimal DurationInHours { get; set; }
        public LocationInfo From { get; set; }
        public LocationInfo To { get; set; }
        public int? CarTypeId { get; set; }
        public int? ClientId { get; set; }*/
    console.log("calling service", bookingInfo);

    return this.service.get("bookingApi/getTripPrices", {
      params: {
        bookingInfo: bookingInfo,
      },
    });
  }

  checkStripeSourceStatus(sourceId, websiteId) {
    return this.service.get(
      "bookingApi/checkStripeSourceStatus/" + sourceId + "/" + websiteId
    );
  }

  /**
   *
   * @param {any} bookingInfo
   */
  getTripPriceForAllCar(bookingInfo) {
    /*public int WebsiteId { get; set; }
        public string PickupDateTime { get; set; }
        public BookingType Type { get; set; }
        public decimal DurationInHours { get; set; }
        public LocationInfo From { get; set; }
        public LocationInfo To { get; set; }
        public int? CarTypeId { get; set; }
        public int? ClientId { get; set; }*/
    console.log("calling service", bookingInfo);

    return this.service.post(
      "bookingApi/getBookingPriceForAllCarsV1",
      bookingInfo
    );
    // {
    //     params: {
    //         bookingInfo: bookingInfo
    //     }
    // });
  }

  /**
   *
   * @param {string} bguid
   * @param {string} stripeSourceId
   */
  chargeBookingWithStripe(bguid, stripeSourceId) {
    return this.service.post("bookingApi/chargeBookingWithStripe", {
      bookingGuid: bguid,
      stripeSourceId: stripeSourceId,
    });
  }

  /**
   *
   * @param {string} guid
   */
  getBookingInfo(guid) {
    return this.service.get("bookingApi/getBookingInfo/" + guid);
  }

  /**
   *
   * @param {string} apiKey
   */
  getAvailableCarTypes(apiKey) {
    return this.service.get("bookingApi/getWebsiteCarTypes/" + apiKey);
  }

  /**
   *
   * @param {Object} contactForm
   * @param {string} contactForm.apiKey - api key
   * @param {string} contactForm.name - customer name
   * @param {string} contactForm.firstName - customer first name
   * @param {string} contactForm.lastName - customer last name
   * @param {string} contactForm.phone - customer phone
   * @param {string} contactForm.email - customer email
   * @param {string} contactForm.message - customer message
   */
  sendContactForm(contactForm) {
    //console.log(contactForm);
    return this.service.post("supportApi/sendContactForm", contactForm);
  }

  /**
   *
   * @param {Object} quotationForm
   * @param {string} quotationForm.name - customer name
   * @param {string} quotationForm.phone - customer phone
   * @param {string} quotationForm.email - customer email
   * @param {string} quotationForm.message - customer message
   * @param {string} quotationForm.from - from location
   * @param {string} quotationForm.to - to location
   * @param {string} quotationForm.hours - number of hours
   * @param {string} quotationForm.pickupAt - pickup at
   */
  sendQuotationForm(quotationForm) {
    return this.service.post(
      "supportApi/sendNotAllowedQuotationForm",
      quotationForm
    );
  }
}

export default new ApiService();